import { useState } from 'react';
import { ArBalancesView, COLLECTIONS, CreateLinkDrawer } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * Collections › Balances (amendment 28 §2.1). The subtraction funnel and the
 * three breakdowns; every Start-a-follow-up carries its description into the
 * builder. The three tabs share this page's siblings.
 */
export function CollectionsPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const [linkOpen, setLinkOpen] = useState(false);

  return (
    <>
      <ArBalancesView
        onSelectTab={(tab) => {
          if (tab === 'follow-ups') void navigate('/collections/follow-ups');
          else if (tab === 'links') void navigate('/collections/links');
        }}
        onOpenSettings={() => { void navigate('/settings/ai/accounts-receivable'); }}
        onCreateLink={() => { setLinkOpen(true); }}
        onNewFollowUp={() => { void navigate('/collections/follow-ups/new'); }}
        onStartFollowUp={(description) => { void navigate(`/collections/follow-ups/new?desc=${encodeURIComponent(description)}`); }}
      />
      <CreateLinkDrawer open={linkOpen} patient={COLLECTIONS.drawerPatient} prefill={null} onClose={() => { setLinkOpen(false); }} />
    </>
  );
}
